// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1zkLv","label":"SetPasswdForm_label__1CW-O"};